module.exports = __webpack_public_path__ + "static/img/t20-cover.10246a80.png";